export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID,
    authority: process.env.REACT_APP_AUTHORITY,
    redirectUri: process.env.REACT_APP_URL,
    postLogoutRedirectUri: '/#login'
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false
  },
  system: {
    loggerOptions: {
      loggerCallback: (containsPii) => {
        if (containsPii) {
          return
        }
      }
    }
  }
}

export const loginRequest = {
  scopes: ['User.Read']
}

export const accessRequest = {
  scopes: [`${process.env.REACT_APP_CLIENT_ID}/.default`]
}

export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me'
}
